document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('.sticky-atc');
  var realSubmit = document.querySelector('.product__info-container .product-form__submit');
  var priceSource = document.querySelector('.product__info-container .price__container .price-item--sale, .product__info-container .price__container .price-item--regular');
  var priceTarget = bar ? bar.querySelector('.sticky-atc__price') : null;
  var stickyButton = bar ? bar.querySelector('.sticky-atc__button') : null;

  if (!bar || !realSubmit) return;

  var syncPrice = function () {
    if (priceSource && priceTarget) {
      priceTarget.textContent = priceSource.textContent.trim();
    }
  };

  var syncDisabled = function () {
    if (!stickyButton) return;
    var disabled = realSubmit.hasAttribute('disabled') || realSubmit.getAttribute('aria-disabled') === 'true';
    stickyButton.disabled = disabled;
    stickyButton.textContent = disabled
      ? realSubmit.textContent.trim()
      : (stickyButton.dataset.label || stickyButton.textContent.trim());
  };

  syncPrice();
  syncDisabled();

  var priceObserver = new MutationObserver(syncPrice);
  var priceContainer = document.querySelector('.product__info-container .price__container');
  if (priceContainer) {
    priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  var submitObserver = new MutationObserver(syncDisabled);
  submitObserver.observe(realSubmit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

  var visibilityObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  visibilityObserver.observe(realSubmit);

  if (stickyButton) {
    stickyButton.dataset.label = stickyButton.textContent.trim();
    stickyButton.addEventListener('click', function () {
      realSubmit.click();
    });
  }
});
